import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'

export default function TableShimmer(){
    return(
        <div className="border border-[#DEDEDE] table-row  h-14 ">
            <td className="px-4 py-4 text-[16px] leading-normal font-medium">
                <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
                    <Skeleton count={1} className='h-[30px] max-w-[80px]' />
                </SkeletonTheme>
            </td>
            <td className="px-4 py-3 text-[16px] leading-normal">
                <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
                    <Skeleton count={1} className='h-[30px] max-w-[240px]' />
                </SkeletonTheme>
            </td>
            <td className="px-4 py-3 text-[16px] leading-normal">
                <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
                    <Skeleton count={1} className='h-[30px] max-w-[200px]' />
                </SkeletonTheme>
            </td>
            <td className="px-4 py-3 text-[16px] leading-normal">
                <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
                    <Skeleton count={1} className='h-[30px] max-w-[200px]' />
                </SkeletonTheme>
            </td>
        </div>
    )
}